{
  "title": "Wallet",
  "subtitle": "Balances are read from the server only. Real operations are not enabled.",
  "real": "Main balance",
  "bonus": "Bonus",
  "reserved": "Reserved",
  "unavailable": "Balance information unavailable",
  "deposit": "Deposit",
  "withdraw": "Withdraw",
  "history": "History",
  "comingSoon": "Payment flows coming soon"
}
